import React, { useCallback } from 'react';
import { IEditRestaurantState } from '../../../../../../../../editRestaurantState/editRestaurantContext';
import { ValidateFields } from 'rc-field-form/es/interface';
import { ISupplier } from 'types';
import { SupplierTaxIDField } from './components/SupplierTaxIDField';
import { SupplierPhoneNumberField } from './components/SupplierPhoneNumberField';
import { SupplierNameField } from './components/SupplierNameField';
import { IsOpenPriceCheckbox } from './components/IsOpenPriceCheckbox';
import { OpenPriceField } from './components/OpenPriceField';
import classNames from 'classnames';
import style from './Supplier.module.scss';

interface IProps {
	changeSupplier: ({ key, value }: { key: keyof IEditRestaurantState['supplier']; value: string }) => void;
	toggleIsOpenPriceServiceCharge: () => void;
	changeOpenPricePercent: (value: Nullable<number>) => void;
	revalidateForm: ValidateFields;
	isOpenPriceServiceCharge: boolean;
	supplier: ISupplier;
}

export const Supplier: React.FC<IProps> = React.memo(
	({
		changeSupplier,
		toggleIsOpenPriceServiceCharge,
		changeOpenPricePercent,
		revalidateForm,
		isOpenPriceServiceCharge,
		supplier,
	}) => {
		const rowWithAlignItemsCenterClasses = classNames(style.row, style.alignItemsCenter);

		const handleChangeSupplierTaxpayerId = useCallback(
			(value: string) => {
				changeSupplier({ key: 'taxpayerId', value });
				revalidateForm(['supplierPhone', 'supplierName']);
			},
			[changeSupplier, revalidateForm],
		);

		const handleChangeSupplierPhone = useCallback(
			(value: string) => {
				changeSupplier({ key: 'phone', value });
				revalidateForm(['supplierTaxpayerId', 'supplierName']);
			},
			[changeSupplier, revalidateForm],
		);

		const handleChangeSupplierName = useCallback(
			(value: string) => {
				changeSupplier({ key: 'name', value });
				revalidateForm(['supplierTaxpayerId', 'supplierPhone']);
			},
			[changeSupplier, revalidateForm],
		);

		return (
			<>
				<div className={style.row}>
					<SupplierTaxIDField
						changeSupplierTaxpayerId={handleChangeSupplierTaxpayerId}
						supplierPhone={supplier.phone}
						supplierName={supplier.name}
					/>
					<SupplierPhoneNumberField
						changeSupplierPhone={handleChangeSupplierPhone}
						supplierTaxpayerId={supplier.taxpayerId}
						supplierName={supplier.name}
					/>
				</div>
				<div className={rowWithAlignItemsCenterClasses}>
					<SupplierNameField
						changeSupplierName={handleChangeSupplierName}
						supplierTaxpayerId={supplier.taxpayerId}
						supplierPhone={supplier.phone}
					/>
					<IsOpenPriceCheckbox
						toggleIsOpenPriceServiceCharge={toggleIsOpenPriceServiceCharge}
						isOpenPriceServiceCharge={isOpenPriceServiceCharge}
					/>
				</div>
				{isOpenPriceServiceCharge && (
					<div className={style.row}>
						<div className={style.flex1} />
						<OpenPriceField changeOpenPricePercent={changeOpenPricePercent} />
					</div>
				)}
			</>
		);
	},
);
